// Message helper functions to reduce code duplication

export const updateLastBotMessage = (messages, newText) => {
  const updatedMessages = [...messages];
  updatedMessages[updatedMessages.length - 1] = {
    text: newText,
    sender: "bot"
  };
  return updatedMessages;
};

export const updateLastBotMessageWithData = (messages, messageData) => {
  const updatedMessages = [...messages];
  updatedMessages[updatedMessages.length - 1] = {
    ...messageData,
    sender: "bot"
  };
  return updatedMessages;
};

export const addBotMessage = (messages, text, additionalData = {}) => {
  return [...messages, { text, sender: "bot", ...additionalData }];
};

export const addUserMessage = (messages, text) => {
  return [...messages, { text, sender: "user" }];
};

export const addFileMessage = (messages, fileCount, fileNames) => {
  return [
    ...messages,
    {
      type: "files",
      fileCount,
      fileNames,
      sender: "user"
    }
  ];
};
